export const approvalsRoutesConfig = {
  main: `/approvals`,
  internalRoutes: {
    confirmJob: ':jobApprovalItemId/confirm/job',
    confirmJobRequest: ':jobApprovalItemId/confirm/job-request',
    new: 'new',
  },
} as const;
